import type { ComponentPropsWithoutRef } from "react";

export const PeopleIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M18.7207 21C18.7207 18.8783 17.8778 16.8434 16.3776 15.3431C14.8773 13.8429 12.8424 13 10.7207 13M10.7207 13C8.59897 13 6.56414 13.8429 5.06385 15.3431C3.56356 16.8434 2.7207 18.8783 2.7207 21M10.7207 13C13.4821 13 15.7207 10.7614 15.7207 8C15.7207 5.23858 13.4821 3 10.7207 3C7.95928 3 5.7207 5.23858 5.7207 8C5.7207 10.7614 7.95928 13 10.7207 13ZM22.7207 20C22.7207 16.63 20.7207 13.5 18.7207 12C19.3781 11.5068 19.9038 10.8591 20.2513 10.1143C20.5987 9.36945 20.7572 8.55047 20.7127 7.7298C20.6682 6.90913 20.4221 6.11209 19.9962 5.4092C19.5702 4.70631 18.9776 4.11926 18.2707 3.7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
